import React from 'react';
import { Avatar, Button } from '@material-ui/core';
import { CaretRight, ArrowsClockwise } from 'phosphor-react';
import { isEmpty } from 'lodash';

import { useDispatch, useSelector } from '../../../../lib/react-redux-hooks';
import {
  fetchUsersTeam,
  openYourTeamModal,
} from '../../../../actions/dashboard';
import styles from '../../../../styles/sass/components/YourTeam.module.scss';
import LogoLoader from '../../../utility/LogoLoader';

const YourTeamComponent = () => {
  const dispatch = useDispatch();
  const { token, yourTeam, yourTeamLoading } = useSelector((state: any) => {
    return {
      yourTeam: state.dashboard.yourTeam,
      yourTeamLoading: state.dashboard.yourTeamLoading,
      token: state.auth.token,
    };
  });

  React.useEffect(() => {
    if (isEmpty(yourTeam) && token) {
      fetchAgents();
    }
  }, [token]);

  const fetchAgents = () => {
    dispatch(fetchUsersTeam(token));
  };

  const renderAgents = (yourTeam: any[]) => {
    return yourTeam.map((agent: any, index: number) => {
      return (
        <div
          key={index}
          className={styles.agentContainer}
          onClick={() => dispatch(openYourTeamModal(agent))}
        >
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Avatar
              src={agent.picture}
              style={{
                height: 50,
                width: 50,
                position: 'static',
              }}
            />
            <div className={styles.agentNameContainer}>
              <div className={styles.agentName}>
                {agent.firstName} {agent.lastName}
              </div>
              <div className={styles.agentRole}>
                {agent.title === 'Client Success Manager'
                  ? 'Experience Manager'
                  : agent.title}
              </div>
            </div>
          </div>
          <button className={styles.caretButton}>
            <CaretRight
              size={32}
              color="#443461"
              weight="regular"
              style={{ cursor: 'pointer' }}
            />
          </button>
        </div>
      );
    });
  };
  return (
    <div className={styles.mainContainer}>
      <div className="row between-xs" style={{ marginBottom: 10 }}>
        <h3 className={styles.heading}>Your Team</h3>
      </div>
      {yourTeamLoading ? (
        <LogoLoader imageProps={{ style: { height: 150, width: 150 } }} />
      ) : isEmpty(yourTeam) ? (
        <p>You have not been assigned an agent yet</p>
      ) : (
        renderAgents(yourTeam)
      )}
    </div>
  );
};

export default YourTeamComponent;
